import { GeoService } from "./GeoService"
import { GeographicalService } from "./GeographicalService"

export const initializeGeoservice = () => {
    /**
     * Intializing geoservice. In case of new plugin
     * Update GeoService.MapWrapper()
    */
    const geoSource: GeoService.MapSource = new GeoService.MapWrapper()
    GeographicalService.details.setSource(geoSource)
}